import { render, staticRenderFns } from "./Sabbaticals.vue?vue&type=template&id=4875a62b&"
import script from "./Sabbaticals.vue?vue&type=script&lang=js&"
export * from "./Sabbaticals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports